import $env from '@/tools/environment.js';
import api from '@/api.js';

const isIntrum = $env('VITE_CUSTOM_STYLE_SHEET') === '/assets/intrum/styles.css';

// List of pages and their required permissions (if any) - Order is relevant
const routePermissions = {
    DashboardIndex: ['DASHBOARD_ACCESS'],
    UserIndex: ['USER_ACCESS', 'USER_MANAGE'],
    ExpiredSoonUserIndex: ['USER_MANAGE', 'RESPONSIBLE_USER_MANAGE'],
    UserDetail: ['USER_ACCESS', 'USER_MANAGE'],
    LocalUserIndex: ['USER_ACCESS', 'USER_MANAGE'],
    ProfileUserIndex: ['USER_PROFILE_ACCESS', 'USER_MANAGE', 'RESPONSIBLE_USER_MANAGE'],
    CompanyIndex: ['COMPANY_ACCESS', 'COMPANY_MANAGE'],
    CompanyDetail: ['COMPANY_ACCESS', 'COMPANY_MANAGE'],
    TeamIndex: ['TEAM_ACCESS', 'TEAM_MANAGE'],
    OfficeIndex: ['OFFICE_ACCESS', 'OFFICE_MANAGE'],
    DepartmentIndex: ['DEPARTMENT_ACCESS', 'DEPARTMENT_MANAGE'],
    RoleIndex: ['ROLE_ACCESS', 'ROLE_MANAGE'],
    RoleDetail: ['ROLE_ACCESS', 'ROLE_MANAGE'],
    ProviderIndex: ['PROVIDER_ACCESS', 'PROVIDER_MANAGE'],
    TriggerIndex: ['TRIGGER_ACCESS', 'TRIGGER_MANAGE'],
    TriggerEventIndex: ['TRIGGER_ACCESS', 'TRIGGER_MANAGE'],
    ApplicationDetail: ['APPLICATION_ACCESS', 'APPLICATION_MANAGE'],
    ApplicationIndex: ['APPLICATION_ACCESS', 'APPLICATION_MANAGE'],
    AuditChangeIndex: ['AUDIT_ACCESS'],
    AuditLoginIndex: ['AUDIT_ACCESS'],
    ...{
        FromLogin: [],
        FromGenesys: [],
        Index: [],
        Index2: [],
        Login: [],
        LoginError: [],
        LoginUsername: [],
        LoginForgotPassword: [],
        LoginResetPassword: [],
        LoginChangePassword: [],
        LoginWithAdUsernameAndPassword: [],
        Logout: [],
        NotFound: [],
    },
};

// Some pages are only available if the app has some features enabled
const routeFeatures = {
    DashboardIndex: 'dashboard',
    LocalUserIndex: 'login.local',
    ProfileUserIndex: 'profiles.user_index',
    ProviderIndex: 'login.local',
    ExpiredSoonUserIndex: 'users.validity.enabled',
};

// Some pages have other conditions to be met
const routeOther = {
    AuditIndex: () => isIntrum,
    DashboardIndex: () => isIntrum,
    LoginWithAdUsernameAndPassword: () => isIntrum,
    OfficeIndex: () => isIntrum,
    RoleDetail: () => isIntrum,
    RoleIndex: () => isIntrum,
    TeamIndex: () => isIntrum,
    TriggerIndex: () => isIntrum,
};

// List of pages that are accessible to the current user
export const accessiblePages = (user, features) => Object.keys(routePermissions).filter((page) => {
    const hasPermissions = user === null || (routePermissions[page] || []).length === 0 || routePermissions[page].some((permission) => api.can(permission));
    const hasFeature = features === null || !routeFeatures[page] || routeFeatures[page].split('.').reduce((obj, key) => obj?.[key], features);
    const meetsOtherCondition = routeOther[page] === undefined || routeOther[page]();

    return hasPermissions && hasFeature && meetsOtherCondition;
});

// Check if the current user can access a page
export const canAccessPage = (page, user, features) => accessiblePages(user, features).includes(page);

// Get the first accessible page
export const firstAccessiblePage = (user, features) => accessiblePages(user, features)[0];